import { useEffect, useState } from "react";

/**
 * For a field whose every keystroke would reach a third party. PDOK publishes no rate limit, so
 * the budget is a guess - docs/adr/0060-a-meldadres-is-chosen-not-typed.md flags it for revisiting.
 */
export function useDebounced<T>(value: T, ms: number) {
  const [uitgesteld, setUitgesteld] = useState(value);

  useEffect(() => {
    const timer = setTimeout(() => setUitgesteld(value), ms);

    return () => clearTimeout(timer);
  }, [value, ms]);

  return uitgesteld;
}
